import React, { Component } from 'react';
import { Breadcrumb, Col, Row, notification } from 'antd';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Link } from 'react-router-dom';
import { SubmissionError } from 'redux-form';

import CampaignForm from './components/CampaignForm';
import CampaignStatsCard from './components/CampaignStatsCard';
import PublicPreviewCard from './components/PublicPreviewCard';
import { createGiveawayCampaign, getApiErrorMessage, getCurrentGiveawayState } from './api';
import { pickCampaignFormValues } from './campaignFormValues';

class NewCampaign extends Component {
  state = {
    currentError: '',
    currentLoading: true,
    currentRefreshing: false,
    currentState: null,
  };

  componentDidMount() {
    this.loadCurrentGiveaway();
  }

  loadCurrentGiveaway = (refresh = false) => {
    this.setState(refresh ? { currentRefreshing: true, currentError: '' } : { currentLoading: true, currentError: '' });
    return getCurrentGiveawayState()
      .then((currentState) => {
        this.setState({ currentState });
      })
      .catch((error) => {
        this.setState({
          currentError: getApiErrorMessage(error, 'Failed to load the public giveaway preview.'),
        });
      })
      .finally(() => {
        this.setState(refresh ? { currentRefreshing: false } : { currentLoading: false });
      });
  };

  handleSubmit = (data) => {
    const { push } = this.props;
    const record = pickCampaignFormValues(data);
    return createGiveawayCampaign(record)
      .then((campaign) => {
        notification.success({
          message: 'Campaign created',
          description: `${campaign.title} is ready to manage.`,
        });
        push(`/giveaway/${campaign._id}/edit`);
      })
      .catch((error) => {
        throw new SubmissionError({
          _error: getApiErrorMessage(error, 'Failed to create giveaway campaign.'),
        });
      });
  }

  render() {
    const { currentError, currentLoading, currentRefreshing, currentState } = this.state;

    return (
      <div id="giveaway-new">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/giveaway">Giveaway</Link></Breadcrumb.Item>
          <Breadcrumb.Item>New Campaign</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <Row gutter={16}>
            <Col xs={24} lg={14}>
              <CampaignStatsCard campaign={null} loading={false} />
              <CampaignForm
                key="giveaway-new-campaign"
                initialValues={{ status: 'draft', winnerCount: 1 }}
                onSubmit={this.handleSubmit}
                cancelPath="/giveaway"
                saveLabel="Create Campaign"
              />
            </Col>
            <Col xs={24} lg={10}>
              <PublicPreviewCard
                data={currentState}
                error={currentError}
                loading={currentLoading}
                onRefresh={() => this.loadCurrentGiveaway(true)}
                refreshLoading={currentRefreshing}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default connect(null, { push })(NewCampaign);
